import Vue from 'vue'
import * as types from 'store/mutation-types'

const actions = {
  loadEtfBriefInfo({ commit, dispatch }, { symbol, market }) {
    const etfData = () =>
      Vue.http.get(`~stock/etf/holdings/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return {}
        }
        return resp.data.data
      })

    const usFunds = () =>
      Vue.http
        .get(`~stock/stock_info/publicity_fund_with_medium/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.fund
        })

    const hkFunds = () =>
      Vue.http
        .get(`~stock/hkstock/stock_info/publicity_fund_with_medium/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.fund
        })

    const map = {
      US: usFunds,
      HK: hkFunds
    }
    return Promise.all([etfData(), map[market]()]).then(([etfData, funds]) => {
      return commit(types.LOAD_BRIEF_DATA, { etfData, funds })
    })
  }
}

export default {
  actions
}
